<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-toolbar class="md-success">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <hierarchy-menu></hierarchy-menu>
          </div>
        </div>
      </md-toolbar>
      <br />
    </div>

    <div class="md-layout-item" v-if="!getStatus()">
      <!-- <h4 class="info-text">Upload Successful</h4> -->
      <md-empty-state
        md-icon="power_settings_new"
        md-label="Device is Offline"
        md-description="Dashboard will be shown when device will be Online"
      ></md-empty-state>
    </div>

    <div v-if="getStatus() && (getDeviceType() == 'PTE_USB')" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Generator</h4>
        </md-card-header>
        <md-card-content>
          <!-- voltage -->
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">Voltage</label>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('U_L1') && setData.U.L1.touched },
                { 'md-error': errors.has('U_L1') }
              ]"
              >
                <label>L1</label>

                <md-input
                  v-model="setData.U.L1.value"
                  data-vv-name="U_L1"
                  type="text"
                  v-validate="modelValidations.voltage"
                  :class="{'item-change': setData.U.L1.prevVal != setData.U.L1.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('U_L1') && setData.U.L1.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('U_L2') && setData.U.L2.touched },
                { 'md-error': errors.has('U_L2') }
              ]"
              >
                <label>L2</label>
                <md-input
                  v-model="setData.U.L2.value"
                  data-vv-name="U_L2"
                  type="text"
                  v-validate="modelValidations.voltage"
                  :class="{'item-change': setData.U.L2.prevVal != setData.U.L2.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L2')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('U_L2') && setData.U.L2.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('U_L3') && setData.U.L3.touched },
                { 'md-error': errors.has('U_L3') }
              ]"
              >
                <label>L3</label>
                <md-input
                  v-model="setData.U.L3.value"
                  data-vv-name="U_L3"
                  type="text"
                  v-validate="modelValidations.voltage"
                  :class="{'item-change': setData.U.L3.prevVal != setData.U.L3.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('U_L3')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('U_L3') && setData.U.L3.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <label class="md-layout-item md-size-5 md-form-label">V</label>
          </div>

          <!-- currnet -->
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">Current</label>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('I_L1') && setData.I.L1.touched },
                { 'md-error': errors.has('I_L1') }
              ]"
              >
                <label>L1</label>

                <md-input
                  v-model="setData.I.L1.value"
                  data-vv-name="I_L1"
                  type="text"
                  v-validate="modelValidations.current"
                  :class="{'item-change': setData.I.L1.prevVal != setData.I.L1.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('I_L1')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('I_L1') && setData.I.L1.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('I_L2') && setData.I.L2.touched },
                { 'md-error': errors.has('I_L2') }
              ]"
              >
                <label>L2</label>
                <md-input
                  v-model="setData.I.L2.value"
                  data-vv-name="I_L2"
                  type="text"
                  v-validate="modelValidations.currnet"
                  :class="{'item-change': setData.I.L2.prevVal != setData.I.L2.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('I_L2')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('I_L2') && setData.I.L2.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('I_L3') && setData.I.L3.touched },
                { 'md-error': errors.has('I_L3') }
              ]"
              >
                <label>L3</label>
                <md-input
                  v-model="setData.I.L3.value"
                  data-vv-name="I_L3"
                  type="text"
                  v-validate="modelValidations.current"
                  :class="{'item-change': setData.I.L3.prevVal != setData.I.L3.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('I_L3')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('I_L3') && setData.I.L3.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
            <label class="md-layout-item md-size-5 md-form-label">A</label>
          </div>

          <!-- φI -->
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">φ I</label>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('ANGLE_I_L1') && setData.ANGLE_I.L1.touched },
                { 'md-error': errors.has('ANGLE_I_L1') }
              ]"
              >
                <label>L1</label>

                <md-input
                  v-model="setData.ANGLE_I.L1.value"
                  data-vv-name="ANGLE_I_L1"
                  type="text"
                  v-validate="modelValidations.angle"
                  :class="{'item-change': setData.ANGLE_I.L1.prevVal != setData.ANGLE_I.L1.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ANGLE_I_L1')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('ANGLE_I_L1') && setData.ANGLE_I.L1.touched"
                  >done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('ANGLE_I_L2') && setData.ANGLE_I.L2.touched },
                { 'md-error': errors.has('ANGLE_I_L2') }
              ]"
              >
                <label>L2</label>
                <md-input
                  v-model="setData.ANGLE_I.L2.value"
                  data-vv-name="ANGLE_I_L2"
                  type="text"
                  v-validate="modelValidations.angle"
                  :class="{'item-change': setData.ANGLE_I.L2.prevVal != setData.ANGLE_I.L2.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ANGLE_I_L2')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('ANGLE_I_L2') && setData.ANGLE_I.L2.touched"
                  >done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('ANGLE_I_L3') && setData.ANGLE_I.L3.touched },
                { 'md-error': errors.has('ANGLE_I_L3') }
              ]"
              >
                <label>L3</label>
                <md-input
                  v-model="setData.ANGLE_I.L3.value"
                  data-vv-name="ANGLE_I_L3"
                  type="text"
                  v-validate="modelValidations.angle"
                  :class="{'item-change': setData.ANGLE_I.L3.prevVal != setData.ANGLE_I.L3.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ANGLE_I_L3')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('ANGLE_I_L3') && setData.ANGLE_I.L3.touched"
                  >done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
            <label class="md-layout-item md-size-5 md-form-label">°</label>
          </div>

          <!-- φU -->
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">φ U</label>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('ANGLE_U_L1') && setData.ANGLE_U.L1.touched },
                { 'md-error': errors.has('ANGLE_U_L1') }
              ]"
              >
                <label>L1</label>

                <md-input
                  v-model="setData.ANGLE_U.L1.value"
                  data-vv-name="ANGLE_U_L1"
                  type="text"
                  v-validate="modelValidations.angle"
                  :class="{'item-change': setData.ANGLE_U.L1.prevVal != setData.ANGLE_U.L1.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ANGLE_U_L1')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('ANGLE_U_L1') && setData.ANGLE_U.L1.touched"
                  >done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('ANGLE_U_L2') && setData.ANGLE_U.L2.touched },
                { 'md-error': errors.has('ANGLE_U_L2') }
              ]"
              >
                <label>L2</label>
                <md-input
                  v-model="setData.ANGLE_U.L2.value"
                  data-vv-name="ANGLE_U_L2"
                  type="text"
                  v-validate="modelValidations.angle"
                  :class="{'item-change': setData.ANGLE_U.L2.prevVal != setData.ANGLE_U.L2.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ANGLE_U_L2')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('ANGLE_U_L2') && setData.ANGLE_U.L2.touched"
                  >done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('ANGLE_U_L3') && setData.ANGLE_U.L3.touched },
                { 'md-error': errors.has('ANGLE_U_L3') }
              ]"
              >
                <label>L3</label>
                <md-input
                  v-model="setData.ANGLE_U.L3.value"
                  data-vv-name="ANGLE_U_L3"
                  type="text"
                  v-validate="modelValidations.angle"
                  :class="{'item-change': setData.ANGLE_U.L3.prevVal != setData.ANGLE_U.L3.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('ANGLE_U_L3')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('ANGLE_U_L3') && setData.ANGLE_U.L3.touched"
                  >done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
            <label class="md-layout-item md-size-5 md-form-label">°</label>
          </div>

          <!-- FREQ -->
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">Frequency</label>

            <div class="md-layout-item md-size-25">
              <md-field
                :class="[
                { 'md-valid': !errors.has('freq') && setData.freq.touched },
                { 'md-error': errors.has('freq') }
              ]"
              >
                <md-input
                  v-model="setData.freq.value"
                  data-vv-name="freq"
                  type="text"
                  v-validate="modelValidations.frequency"
                  :class="{'item-change': setData.freq.prevVal != setData.freq.value}"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('freq')">close</md-icon>
                </slide-y-down-transition>

                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('freq') && setData.freq.touched">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
            <label class="md-layout-item md-size-5 md-form-label">Hz</label>
          </div>

          <div class="modal-footer">
            <md-button class="md-danger" v-if="status.running" @click="stopGenerate()">Stop</md-button>
            <md-button class="md-warning" @click="getGeneratorSetData()">Refresh</md-button>
            <md-button
              class="md-primary"
              v-if="!status.running"
              @click="setGeneratorSetData()"
            >Start</md-button>
            <md-button
              class="md-primary"
              v-if="status.running"
              @click="setGeneratorSetData()"
            >Update</md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div v-if="getStatus()" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Load values</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="loadValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1">
                <animated-number :value="item.L1" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="L2">
                <animated-number :value="item.L2" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="L3">
                <animated-number :value="item.L3" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="Unit">{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div v-if="getStatus()" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">More values</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="moreValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1">
                <animated-number :value="item.L1" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="L2">
                <animated-number :value="item.L2" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="L3">
                <animated-number :value="item.L3" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="Unit">{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div v-if="getStatus()" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Energy values</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="energyDataTable" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1">
                <animated-number :value="item.L1" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="L2">
                <animated-number :value="item.L2" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="L3">
                <animated-number :value="item.L3" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="SUM">
                <animated-number :value="item.SUM" :formatValue="numberFormat" :duration="1000" />
              </md-table-cell>
              <md-table-cell md-label="Unit">{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import snackBar from "@/components/SnackBar";
import hierarchyMenu from "@/components/HierarchyMenu";
import { SlideYDownTransition } from "vue2-transitions";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import AnimatedNumber from "animated-number-vue";

export default {
  components: {
    "hierarchy-menu": hierarchyMenu,
    "snack-bar": snackBar,
    SlideYDownTransition,
    AnimatedNumber
  },

  data() {
    return {
      modelValidations: {
        voltage: {
          required: true,
          max_value: 320,
          min_value: 0
        },
        current: {
          required: true,
          max_value: 120,
          min_value: 0
        },
        angle: {
          required: true,
          max_value: 360,
          min_value: 0
        },
        frequency: {
          required: true,
          max_value: 70,
          min_value: 40
        }
      },
      status: {
        running: false,
        buttonText: ""
      },
      setData: {
        U: {
          L1: {
            value: "-",
            touched: false
          },
          L2: {
            value: "-",
            touched: false
          },
          L3: {
            value: "-",
            touched: false
          }
        },
        I: {
          L1: {
            value: "-",
            touched: false
          },
          L2: {
            value: "-",
            touched: false
          },
          L3: {
            value: "-",
            touched: false
          }
        },
        ANGLE_U: {
          L1: {
            value: "-",
            touched: false
          },
          L2: {
            value: "-",
            touched: false
          },
          L3: {
            value: "-",
            touched: false
          }
        },
        ANGLE_I: {
          L1: {
            value: "-",
            touched: false
          },
          L2: {
            value: "-",
            touched: false
          },
          L3: {
            value: "-",
            touched: false
          }
        },
        freq: {
          value: "-",
          touched: false
        }
      },

      loadValues: [
        {
          id: 1,
          value: "Voltage [U]",
          unit: "V",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 2,
          value: "Current [I]",
          unit: "A",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 3,
          value: "Phase of Uₚₙ Voltage [φᵤ]",
          unit: "°",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 4,
          value: "Phase of Current [φᵢ]",
          unit: "°",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 5,
          value: "Power factor [cos φ]",
          unit: "",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 6,
          value: "Active power [P]",
          unit: "W",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 7,
          value: "Reactive power [Q]",
          unit: "var",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 8,
          value: "Apparent power [S]",
          unit: "VA",
          L1: "-",
          L2: "-",
          L3: "-"
        }
      ],
      moreValues: [
        {
          id: 1,
          value: "Distortion Factor of Voltage [DFᵤ]",
          unit: "%",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 2,
          value: "Distortion Factor of Current [DFᵢ]",
          unit: "%",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 3,
          value: "Phase to phase voltage [Uₚₚ]",
          unit: "V",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 4,
          value: "Phase of Uₚₚ Voltage [φᵤₚₚ]",
          unit: "°",
          L1: "-",
          L2: "-",
          L3: "-"
        }
      ],
      energyDataTable: [
        {
          id: 1,
          value: "Active energy [Eₚ]",
          unit: "Wh",
          L1: "-",
          L2: "-",
          L3: "-",
          SUM: "-"
        },
        {
          id: 2,
          value: "Reactive energy [Eq]",
          unit: "varh",
          L1: "-",
          L2: "-",
          L3: "-",
          SUM: "-"
        },
        {
          id: 3,
          value: "Apparent energy [Eₛ]",
          unit: "VAh",
          L1: "-",
          L2: "-",
          L3: "-",
          SUM: "-"
        }
      ]
    };
  },

  computed: {
    WSmessage() {
      return this.$store.getters.getDataMessage;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  watch: {
    WSmessage: function(payload, oldPayload) {
      if (payload.U) {
        this.loadValues[0].L1 = payload.U.L1;
        this.loadValues[0].L2 = payload.U.L2;
        this.loadValues[0].L3 = payload.U.L3;
      }

      if (payload.I) {
        this.loadValues[1].L1 = payload.I.L1;
        this.loadValues[1].L2 = payload.I.L2;
        this.loadValues[1].L3 = payload.I.L3;
      }

      if (payload.F_U) {
        this.loadValues[2].L1 = payload.F_U.L1;
        this.loadValues[2].L2 = payload.F_U.L2;
        this.loadValues[2].L3 = payload.F_U.L3;
      }

      if (payload.F_I) {
        this.loadValues[3].L1 = payload.F_I.L1;
        this.loadValues[3].L2 = payload.F_I.L2;
        this.loadValues[3].L3 = payload.F_I.L3;
      }

      if (payload.PF) {
        this.loadValues[4].L1 = payload.PF.L1;
        this.loadValues[4].L2 = payload.PF.L2;
        this.loadValues[4].L3 = payload.PF.L3;
      }

      if (payload.P) {
        this.loadValues[5].L1 = payload.P.L1;
        this.loadValues[5].L2 = payload.P.L2;
        this.loadValues[5].L3 = payload.P.L3;
      }

      if (payload.Q) {
        this.loadValues[6].L1 = payload.Q.L1;
        this.loadValues[6].L2 = payload.Q.L2;
        this.loadValues[6].L3 = payload.Q.L3;
      }

      if (payload.S) {
        this.loadValues[7].L1 = payload.S.L1;
        this.loadValues[7].L2 = payload.S.L2;
        this.loadValues[7].L3 = payload.S.L3;
      }

      if (payload.DF_U) {
        this.moreValues[0].L1 = payload.DF_U.L1;
        this.moreValues[0].L2 = payload.DF_U.L2;
        this.moreValues[0].L3 = payload.DF_U.L3;
      }

      if (payload.DF_I) {
        this.moreValues[1].L1 = payload.DF_I.L1;
        this.moreValues[1].L2 = payload.DF_I.L2;
        this.moreValues[1].L3 = payload.DF_I.L3;
      }

      if (payload.U_PP) {
        this.moreValues[2].L1 = payload.U_PP.L1;
        this.moreValues[2].L2 = payload.U_PP.L2;
        this.moreValues[2].L3 = payload.U_PP.L3;
      }

      if (payload.F_UPP) {
        this.moreValues[3].L1 = payload.F_UPP.L1;
        this.moreValues[3].L2 = payload.F_UPP.L2;
        this.moreValues[3].L3 = payload.F_UPP.L3;
      }

      if (payload.E_I) {
        this.energyDataTable[0].L1 = payload.E_I.L1;
        this.energyDataTable[0].L2 = payload.E_I.L2;
        this.energyDataTable[0].L3 = payload.E_I.L3;
        this.energyDataTable[0].SUM =
          payload.E_I.L1 + payload.E_I.L2 + payload.E_I.L3;
      }

      if (payload.Q_E) {
        this.energyDataTable[1].L1 = payload.Q_E.L1;
        this.energyDataTable[1].L2 = payload.Q_E.L2;
        this.energyDataTable[1].L3 = payload.Q_E.L3;
        this.energyDataTable[1].SUM =
          payload.Q_E.L1 + payload.Q_E.L2 + payload.Q_E.L3;
      }

      if (payload.S_E) {
        this.energyDataTable[2].L1 = payload.S_E.L1;
        this.energyDataTable[2].L2 = payload.S_E.L2;
        this.energyDataTable[2].L3 = payload.S_E.L3;
        this.energyDataTable[2].SUM =
          payload.S_E.L1 + payload.S_E.L2 + payload.S_E.L3;
      }
    }
  },

  created() {
    if (this.getStatus()) {
      this.getGeneratorSetData();
    }
  },

  methods: {
    numberFormat(value) {
      return `${Number(value).toFixed(3)}`;
    },

    getStatus() {
      try {
        if (
          this.deviceList[
            this.deviceList.findIndex(e => e.mac == this.selectedDevice.mac)
          ].status == "ONLINE"
        ) {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    getDeviceType() {
      try {
        return this.deviceList[
          this.deviceList.findIndex(e => e.mac == this.selectedDevice.mac)
        ].device;
      } catch (err) {
        return "PTE";
      }
    },

    getGeneratorSetData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applied-precision/generator",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          this.setData.U.L1.prevVal = response.data.data.data.GEN_EFF[0];
          this.setData.U.L1.value = response.data.data.data.GEN_EFF[0];
          this.setData.I.L1.prevVal = response.data.data.data.GEN_EFF[1];
          this.setData.I.L1.value = response.data.data.data.GEN_EFF[1];
          this.setData.U.L2.prevVal = response.data.data.data.GEN_EFF[2];
          this.setData.U.L2.value = response.data.data.data.GEN_EFF[2];
          this.setData.I.L2.prevVal = response.data.data.data.GEN_EFF[3];
          this.setData.I.L2.value = response.data.data.data.GEN_EFF[3];
          this.setData.U.L3.prevVal = response.data.data.data.GEN_EFF[4];
          this.setData.U.L3.value = response.data.data.data.GEN_EFF[4];
          this.setData.I.L3.prevVal = response.data.data.data.GEN_EFF[5];
          this.setData.I.L3.value = response.data.data.data.GEN_EFF[5];

          this.setData.ANGLE_U.L1.prevVal = response.data.data.data.GEN_PHAS[0];
          this.setData.ANGLE_U.L1.value = response.data.data.data.GEN_PHAS[0];
          this.setData.ANGLE_I.L1.prevVal = response.data.data.data.GEN_PHAS[1];
          this.setData.ANGLE_I.L1.value = response.data.data.data.GEN_PHAS[1];
          this.setData.ANGLE_U.L2.prevVal = response.data.data.data.GEN_PHAS[2];
          this.setData.ANGLE_U.L2.value = response.data.data.data.GEN_PHAS[2];
          this.setData.ANGLE_I.L2.prevVal = response.data.data.data.GEN_PHAS[3];
          this.setData.ANGLE_I.L2.value = response.data.data.data.GEN_PHAS[3];
          this.setData.ANGLE_U.L3.prevVal = response.data.data.data.GEN_PHAS[4];
          this.setData.ANGLE_U.L3.value = response.data.data.data.GEN_PHAS[4];
          this.setData.ANGLE_I.L3.prevVal = response.data.data.data.GEN_PHAS[5];
          this.setData.ANGLE_I.L3.value = response.data.data.data.GEN_PHAS[5];

          this.setData.freq.value = response.data.data.data.GEN_FREQ;
          this.setData.freq.prevVal = response.data.data.data.GEN_FREQ;
          this.status.running = response.data.data.data.GENERATE;

          // Object.keys(response.data.data).forEach(dataTypeKey => {
          //   Object.keys(response.data.data[dataTypeKey]).forEach(key => {
          //     if (this.setData[dataTypeKey]) {
          //       if (this.setData[dataTypeKey][key]) {
          //         this.setData[dataTypeKey][key].value =
          //           response.data.data[dataTypeKey][key];
          //         this.setData[dataTypeKey][key].prevVal =
          //           response.data.data[dataTypeKey][key];
          //       }
          //     }
          //   });
          // });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code !== 604) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    setGeneratorSetData() {
      const UI_gen = [
        this.setData.U.L1.value,
        this.setData.I.L1.value,
        this.setData.U.L2.value,
        this.setData.I.L2.value,
        this.setData.U.L3.value,
        this.setData.I.L3.value
      ];

      const PHAS_gen = [
        this.setData.ANGLE_U.L1.value,
        this.setData.ANGLE_I.L1.value,
        this.setData.ANGLE_U.L2.value,
        this.setData.ANGLE_I.L2.value,
        this.setData.ANGLE_U.L3.value,
        this.setData.ANGLE_I.L3.value
      ];

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/applied-precision/generator",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          GEN_EFF: UI_gen.map(x => Number(x)),
          GEN_PHAS: PHAS_gen.map(x => Number(x)),
          GEN_FREQ: Number(this.setData.freq.value),
          generate: true
        },
        withCredentials: true
      })
        .then(response => {
          Object.keys(this.setData).forEach(dataTypeKey => {
            if (dataTypeKey != "freq") {
              Object.keys(this.setData[dataTypeKey]).forEach(key => {
                this.$nextTick(() => {
                  this.setData[dataTypeKey][key].prevVal = this.setData[
                    dataTypeKey
                  ][key].value;
                  this.setData[dataTypeKey][key] = Object.assign(
                    {},
                    this.setData[dataTypeKey][key],
                    this.setData[dataTypeKey][key]
                  );
                });
              });
            }
          });

          this.setData.freq.prevVal = this.setData.freq.value;
          this.status.running = true;
        })
        .catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
    },

    stopGenerate() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/applied-precision/generator",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          generate: false
        },
        withCredentials: true
      })
        .then(response => {
          this.status.running = false;
        })
        .catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
    }
  }
};
</script>

<style scoped>
#map {
  margin: 0;
  max-height: 500px;
}

.normal-header {
  padding: 0 !important;
  min-height: 0px;
}

/* .md-button.md-simple i,
.md-button.md-simple:hover i {
  color: #ffffff !important;
} */

.md-toolbar {
  position: inherit;
}

.modal-header {
  opacity: 1;
}

.stats-layout {
  justify-content: center;
  text-align: center;
}

.stats-title {
  margin-top: -20px;
}

.card-title {
  margin: 10px;
}

.modal-footer {
  padding: 0px 0px 5px;
}

.item-change {
  -webkit-text-fill-color: #f44336 !important;
  font-weight: 700;
}
</style>
